module.exports = __webpack_public_path__ + "static/media/sale-male-left.4e7b7368.png";